import { UserDataTypes, UserDataTypesDependente } from "../store/actions/login";
import { cleanMask } from "./HelperFunctions";

export const mountUserDataPostLogin = (user: any, password: string, loginResponse: any, keepConnected: boolean, dependentes: any) => {

    const userData: UserDataTypes = {
      username: cleanMask(user?.replaceAll("\"", '') ?? ''),
      password: password,
      keepConnected: keepConnected,
      token: loginResponse?.data?.data?.token,
      tokenType: loginResponse?.data?.data?.tokenType,
      expirationDateMilliSeconds: new Date(
        loginResponse.data?.data?.expirationDate
      ).getUTCMilliseconds(),
      refreshToken: loginResponse?.data?.data?.refreshToken,
      dependentes: (dependentes && dependentes.data && dependentes.data.data) ? dependentes?.data?.data : []
    };

    return userData;
}

export const mountUserDataPostLoginDependentes = (user: any, loginResponse: any, dependentes: any) => {
  
   const userData: UserDataTypesDependente = {
      username: cleanMask(user?.replaceAll("\"", '') ?? ''),
      token: loginResponse.token,
      dependentes: dependentes,
      currentDependente: loginResponse
    };

    return userData;
}
